/**
 * Premium Blog System JS
 * Logic for likes, sharing, and interactions.
 */

document.addEventListener('DOMContentLoaded', () => {
    initializeArticleLikes();
    initializeShareButtons();
});

/**
 * Article Likes System
 * Uses localStorage for demo/preview mode.
 * Ready for AJAX/App Proxy persistence.
 */
function initializeArticleLikes() {
    const likeButtons = document.querySelectorAll('.dr-blog--like-btn');
    if (!likeButtons.length) return;

    likeButtons.forEach(btn => {
        const articleId = btn.getAttribute('data-article-id');
        const endpoint = btn.getAttribute('data-like-endpoint');
        const countDisplay = btn.querySelector('.dr-blog--like-count');
        
        // 1. Initial State Check (localStorage)
        const storageKey = `dr_liked_article_${articleId}`;
        const hasLiked = localStorage.getItem(storageKey) === 'true';
        
        if (hasLiked) {
            btn.classList.add('is-active');
        }

        // 2. Click Handler
        btn.addEventListener('click', async (e) => {
            e.preventDefault();
            btn.classList.add('is-loading');

            const currentlyLiked = btn.classList.contains('is-active');
            
            try {
                // If endpoint exists, perform AJAX request
                if (endpoint && endpoint !== '#') {
                    // Placeholder for production AJAX logic:
                    // const response = await fetch(endpoint, {
                    //     method: 'POST',
                    //     body: JSON.stringify({ article_id: articleId, action: currentlyLiked ? 'unlike' : 'like' })
                    // });
                }

                // Simulate/Handle Demo Toggle
                if (currentlyLiked) {
                    btn.classList.remove('is-active');
                    localStorage.removeItem(storageKey);
                    updateLikeCount(countDisplay, -1);
                } else {
                    btn.classList.add('is-active');
                    localStorage.setItem(storageKey, 'true');
                    updateLikeCount(countDisplay, 1);
                }

            } catch (err) {
                console.error('Like action failed:', err);
            } finally {
                btn.classList.remove('is-loading');
            }
        });
    });
}

function updateLikeCount(element, delta) {
    if (!element) return;
    let current = parseInt(element.textContent || '0', 10);
    element.textContent = current + delta;
}

/**
 * Social Sharing Handlers
 */
function initializeShareButtons() {
    const copyBtn = document.querySelector('.dr-blog--share-btn[data-share="copy"]');
    
    if (copyBtn) {
        copyBtn.addEventListener('click', (e) => {
            e.preventDefault();
            const url = window.location.href;
            
            navigator.clipboard.writeText(url).then(() => {
                const originalContent = copyBtn.innerHTML;
                copyBtn.innerHTML = '✓';
                setTimeout(() => {
                    copyBtn.innerHTML = originalContent;
                }, 2000);
            }).catch(err => {
                console.error('Copy failed:', err);
            });
        });
    }

    // Other share buttons (FB, X, LinkedIn) use standard <a> tags with target="_blank"
    // No extra JS needed unless we want tracking or pop-ups.
}
